/**
 * Copyright (c) 2026 Finorda Pty Ltd
 * All rights reserved.
 *
 * This file is part of the Finorda platform.
 * Unauthorised copying, modification or
 * distribution of this software is
 * strictly prohibited.
 *
 * Proprietary and confidential.
 * Governed by Queensland law, Australia.
 */

import { useState, useEffect } from 'react'

const API_URL = import.meta.env.VITE_API_URL

export default function BuildInfo() {
  const [build, setBuild] = useState(null)

  useEffect(() => {
    fetch(`${API_URL}/health`)
      .then(r => r.json())
      .then(data => {
        const info = {
          apiUrl: API_URL,
          ...(data.build || {})
        }
        setBuild(info)
        console.log('[POG] Build fingerprint:', info)
      })
      .catch(() => {
        const info = { apiUrl: API_URL, gitSha: 'unreachable', branch: '—', deployedAt: '—' }
        setBuild(info)
        console.warn('[POG] Build fingerprint: backend unreachable at', API_URL)
      })
  }, [])

  if (!build) return null

  const sha = build.gitSha === 'local' ? 'local' : (build.gitSha || '').slice(0, 7)

  return (
    <div style={{
      position: 'fixed',
      bottom: 8,
      right: 8,
      fontSize: 10,
      fontFamily: 'monospace',
      color: '#999',
      background: 'rgba(255,255,255,0.9)',
      padding: '4px 8px',
      borderRadius: 4,
      zIndex: 9999,
      lineHeight: 1.4,
      pointerEvents: 'none'
    }}>
      <div>API: {API_URL}</div>
      <div>{sha} / {build.branch}</div>
    </div>
  )
}
